// import { useState, useEffect, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import { ReactComponent as ModalCloseIcon } from "../../assets/svg/close-modal.svg";
// import { ReactComponent as MinusSign } from "../../assets/svg/minus-sign.svg";
// import { ReactComponent as PlusSign } from "../../assets/svg/add-circle.svg";
// import { Container, Row, Col } from "react-bootstrap";
// import "../visitor/visitor-create/visitor-create.css";
// import DOMPurify from "dompurify";
// import { createPOVApi, getLocationListApi, getPOVDetailsApi, updatePOVApi } from "./setup-api";
// import AsyncSelect from "react-select/async";
// import { min } from "date-fns";
// import { getDeptApi, getLocationApi } from "../masters/customer/customer-api";

// const CustomerCreateModal = ({ povId, onSuccess, onCancel }) => {
//   const apiUrl = process.env.REACT_APP_API_URL;
//   const navigate = useNavigate();
//   const [errorMessage, setErrorMessage] = useState("");
//   const [locationsOptions, setlocationsOptions] = useState(null);
//   const [multipleGatein, setmultipleGatein] = useState(false);
//   const [selectedLocation, setSelectedLocation] = useState([]);
//   const [selectedDept, setSelectedDept] = useState([]);
//   const handleAssignToDropdownChange = (selectedOptions) => {
//     console.log(selectedOptions);
//     setlocationsOptions(selectedOptions);
//   };
//   const modalStyle = {
//     overlay: { position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0, 0, 0, 0.5)", opacity: 1, display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000 },
//     modal: { backgroundColor: "#ffffff", borderRadius: "16px", boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", width: "718px", overflowY: "auto", minHeight: "fit-content" },
//   };

//   const [loading, setLoading] = useState(false);
//   const [code, setCode] = useState("");
//   const [name, setName] = useState("");
//   const [description, setDescription] = useState("");
//   const [duration, setDuration] = useState("");
//   useEffect(() => {
//     if (povId != null) {
//       getPOVDetails();
//     }
//   }, []);
//   const getLocationData = (inputValue, callback) => {
//     setTimeout(async () => {
//       console.log("Fetching transport options with term:", inputValue);
//       const response = await getLocationApi(inputValue);
//       if (response.status === 200) {
//         if (response.data.success === true) {
//           const options = response.data.suggestionlist.map((item) => ({
//             value: String(item.value),
//             label: String(item.label),
//           }));
//           callback(options);
//         }
//       }
//     }, 1000);
//   };
//   const getDepartmentData = (inputValue, callback) => {
//     setTimeout(async () => {
//       console.log("Fetching transport options with term:", inputValue);
//       const response = await getDeptApi(inputValue);
//       if (response.status === 200) {
//         if (response.data.success === true) {
//           const options = response.data.suggestionlist.map((item) => ({
//             value: String(item.value),
//             label: String(item.label),
//           }));
//           callback(options);
//         }
//       }
//     }, 1000);
//   };
//   const multiselectCustomStyles = {
//     control: (provided) => ({ ...provided, backgroundColor: "#ffffff", borderRadius: "8px", border: "0.7px solid #E5E5E5", padding: "2px", fontWeight: "500", fontSize: "13px", color: "#212129" }),
//     option: (provided, state) => ({ ...provided, backgroundColor: state.isSelected ? "#007bff" : state.isFocused ? "#e0e0e0" : "#fff", color: state.isSelected ? "#fff" : "#333", padding: 10 }),
//     multiValue: (provided) => ({ ...provided, backgroundColor: "#F6F7F8", color: "#212129", borderRadius: "5px", padding: "2px 5px" }),
//     multiValueLabel: (provided) => ({ ...provided, color: "#212129" }),
//     multiValueRemove: (provided) => ({ ...provided, color: "#212129", cursor: "pointer", ":hover": { backgroundColor: "red", color: "white" } }),
//   };

//   const fetchOptions = (inputValue, callback) => {
//     setTimeout(async () => {
//       const response = await getLocationListApi(inputValue);
//       if (response.status === 200 && response.data.success) {
//         const options = response.data.suggestionlist.map((item) => ({ value: String(item.value), label: String(item.label) }));
//         callback(options);
//       }
//     }, 1000);
//   };

//   const [validations, setValidations] = useState({
//     code: "",
//     name: "",
//     description: "",
//     duration: "",
//     locations: "",
//   });

//   const getPOVDetails = async () => {
//     try {
//       const response = await getPOVDetailsApi(povId);
//       if (response.status === true) {
//         console.log(response);
//         var povDetails = response.Purpose_of_visit;
//         console.log(povDetails);
//         setCode(povDetails.code ?? "");
//         setName(povDetails.name ?? "");
//         setDescription(povDetails.description ?? "");
//         setDuration(povDetails.duration ?? "");
//         setlocationsOptions(povDetails.locations?.map((item) => ({ value: String(item.id), label: String(item.location) })));
//         setmultipleGatein(povDetails.multiple_gate_in ?? false);
//       }
//       return response.data;
//     } catch (err) {
//       console.error("Error fetching category:", err);
//     } finally {
//     }
//   };

//   const submitPurposeVisit = async () => {
//     const dataBeforeSanitize = {
//       id: povId != null ? povId : "",
//       code: code,
//       name: name,
//       description: description,
//       duration: duration,
//       locations: locationsOptions?.filter((item) => item.value !== "").map((item) => item.value),
//       multiple_gate_in: multipleGatein,
//     };
//     const dataAfterSanitize = {};
//     Object.entries(dataBeforeSanitize).forEach(([key, value]) => {
//       if (typeof value === "boolean" || typeof value === "number" || Array.isArray(value)) {
//         dataAfterSanitize[key] = value;
//       } else {
//         dataAfterSanitize[key] = DOMPurify.sanitize(value);
//       }
//     });
//     if (povId == null) {
//       const response = await createPOVApi(dataAfterSanitize);
//       if (response.status === 200) {
//         if (response.data.status === true) {
//           onSuccess(response.data);
//         }
//       }

//       if (response.status === 400) {
//         new Promise((resolve, reject) => {
//           const validationTemp = {
//             code: "",
//             name: "",
//             description: "",
//             duration: "",
//           };
//           Object.entries(response.data.error).forEach(([key, value]) => {
//             console.log(`${key}: ${value}`);
//             validationTemp[key] = value.length === 0 ? "" : value[0];
//           });
//           console.log("validationTemp...", validationTemp);
//           setValidations(validationTemp);
//         });
//       }
//     } else {
//       const response = await updatePOVApi(dataAfterSanitize, povId);
//       if (response.status === 200) {
//         if (response.data.status === true) {
//           onSuccess(response.data);
//         }
//       }

//       if (response.status === 400) {
//         new Promise((resolve, reject) => {
//           const validationTemp = {
//             code: "",
//             name: "",
//             description: "",
//             duration: "",
//           };
//           Object.entries(response.data.error).forEach(([key, value]) => {
//             console.log(`${key}: ${value}`);
//             validationTemp[key] = value.length === 0 ? "" : value[0];
//           });
//           console.log("validationTemp...", validationTemp);
//           setValidations(validationTemp);
//         });
//       }
//     }
//   };

//   const [lastKey, setLastKey] = useState("");
//   const handleChange = (event) => {
//     const inputText = event.target.value;
//     if (/^\d{0,2}(:\d{0,2})?$/.test(inputText)) {
//       console.log(event.key);
//       if (lastKey === "Backspace") {
//         setDuration(inputText);
//       } else {
//         setDuration(inputText.length === 2 ? inputText + ":" : inputText);
//       }
//     }
//   };

//   const handleLocationChange = (selectedOptions) => {
//     console.log(selectedOptions);
//     setSelectedLocation(selectedOptions);
//   };
//   const handleDeptChange = (selectedOptions) => {
//     console.log(selectedOptions);
//     setSelectedDept(selectedOptions);
//   };

//   return (
//     <div style={modalStyle.overlay}>
//       <div style={modalStyle.modal}>
//         <div style={{ color: "#ffffff" }}>
//           <div className="modal-header style-justify-between">
//             <div className="add-item-modal-title">{povId != null ? "Edit " : "Add "} Customers</div>
//             <ModalCloseIcon style={{ cursor: "pointer" }} onClick={onCancel} />
//           </div>
//           <div style={{ padding: "16px 24px" }}>
//             <Row style={{ width: "670px" }}>
//               <Col xs={12} sm={12} md={6} style={{ marginBottom: "16px" }}>
//                 <div className="field-title">
//                   Code<span style={{ color: "#FF4444" }}>*</span>
//                 </div>
//                 <input type="text" placeholder="Enter here" className="input-field mt-2 w-100" value={code} onChange={(e) => setCode(e.target.value)} />
//                 <span className="field-error">{validations.code}</span>
//               </Col>

//               <Col xs={12} sm={12} md={6} style={{ marginBottom: "16px" }}>
//                 <div className="field-title">
//                   Customer Name<span style={{ color: "#FF4444" }}>*</span>
//                 </div>
//                 <input type="text" placeholder="Enter here" className="input-field mt-2 w-100" value={name} onChange={(e) => setName(e.target.value)} />
//                 <span className="field-error">{validations.name}</span>
//               </Col>

//               <Col xs={12} sm={12} md={6} style={{ marginBottom: "16px" }}>
//                 <div className="field-title">
//                   Mobile Number<span style={{ color: "#FF4444" }}>*</span>
//                 </div>
//                 <input type="text" placeholder="Enter here" className="input-field mt-2 w-100" value={code} onChange={(e) => setCode(e.target.value)} />
//                 <span className="field-error">{validations.code}</span>
//               </Col>

//               <Col xs={12} sm={12} md={6} style={{ marginBottom: "16px" }}>
//                 <div className="field-title">
//                   Email<span style={{ color: "#FF4444" }}>*</span>
//                 </div>
//                 <input type="text" placeholder="Enter here" className="input-field mt-2 w-100" value={name} onChange={(e) => setName(e.target.value)} />
//                 <span className="field-error">{validations.name}</span>
//               </Col>
//               <Col xs={12} sm={12} md={6} style={{ marginBottom: "16px" }}>
//                 <div className="field-title">
//                   Location
//                   {/* <span style={{ color: "#FF4444" }}>*</span> */}
//                 </div>
//                 <AsyncSelect isMulti cacheOptions value={selectedLocation} loadOptions={getLocationData} onChange={handleLocationChange} defaultOptions placeholder="Select locations" styles={multiselectCustomStyles} isClearable={false} />
//                 <span className="field-error">{validations.locations}</span>
//               </Col>

//               <Col xs={12} sm={12} md={6} style={{ marginBottom: "16px" }}>
//                 <div className="field-title">
//                   Department
//                   {/* <span style={{ color: "#FF4444" }}>*</span> */}
//                 </div>
//                 <AsyncSelect isMulti cacheOptions value={selectedDept} loadOptions={getDepartmentData} onChange={handleDeptChange} defaultOptions placeholder="Select locations" styles={multiselectCustomStyles} isClearable={false} />
//                 <span className="field-error">{validations.locations}</span>
//               </Col>
//             </Row>

//             <Row className="mt-3" style={{ width: "670px" }}>
//               <div className="style-justify-end">
//                 <div onClick={onCancel} className="cancel-modal-btn style-justify-center">
//                   Cancel
//                 </div>
//                 <div className="save-modal-btn style-justify-center" onClick={submitPurposeVisit}>
//                   {povId != null ? "Update " : "Save "}
//                 </div>
//               </div>
//             </Row>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CustomerCreateModal;




import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as ModalCloseIcon } from "../../assets/svg/close-modal.svg";
import { Row, Col } from "react-bootstrap";
import "../visitor/visitor-create/visitor-create.css";
import DOMPurify from "dompurify";
// import { createPOVApi, getLocationListApi, getPOVDetailsApi, updatePOVApi } from "./setup-api";
import AsyncSelect from "react-select/async";
import { getCustomerApi, getDeptApi, getLocationApi, saveCustomerApi, updateCustomerApi } from "../masters/customer/customer-api";
import { ReactComponent as CrossIcon } from "../../assets/svg/close.svg";
const CustomerCreateModal = ({ povId, onSuccess, onCancel }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const [validations, setValidations] = useState({
    code: "",
    name: "",
    email: "",
    contact_number: "",
    locations: "",
    departments: "",
  });
  useEffect(() => {
    if (povId != null) {
      getcustomerDetails();
    }
  }, [povId])

  const handleRemoveEmail = (indexToRemove) => {
    setEmailList((prevList) =>
      prevList.filter((_, index) => index !== indexToRemove)
    );
  };
  const handleRemoveMobile = (indexToRemove) => {
    setMobileList((prevList) =>
      prevList.filter((_, index) => index !== indexToRemove)
    );
  };

  const [emailList, setEmailList] = useState([]);
  const [mobileList, setMobileList] = useState([]);


  const handleAddEmail = () => {
    const trimmedEmail = email.trim();

    // Simple email format regex
    const isValidEmail = (email) =>
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    if (!trimmedEmail) {
      setValidations((prev) => ({
        ...prev,
        email: "Email is required",
      }));
      return;
    }

    if (!isValidEmail(trimmedEmail)) {
      setValidations((prev) => ({
        ...prev,
        email: "Invalid email format",
      }));
      return;
    }

    // Clear validation if all is good
    setValidations((prev) => ({
      ...prev,
      email: "",
    }));
    setEmailList((prevList) => [...prevList, trimmedEmail]);

    // Add email logic here (e.g., pushing to a list, sending to backend, etc.)
    console.log("Email added:", trimmedEmail);

    // Optionally clear the input
    setEmail("");
  };
  const handleAddMobile = () => {
    const trimmedMobile = contactNo.trim();
    if (!trimmedMobile) return;

    setMobileList((prevList) => [...prevList, trimmedMobile]);
    setcontactNo(""); // clear input
  };
  const getcustomerDetails = async () => {
    const response = await getCustomerApi(povId);
    if (response.status === 200) {
      if (response.data.success === true) {
        setName(response.data.customer.name ?? '');
        setCode(response.data.customer.code ?? '');
        setEmail(response.data.customer.email ?? '');
        setcontactNo(response.data.customer.contact_number ?? '');
        setSelectedLocation(response.data.customer.locations ?? [])
        setSelectedDept(response.data.customer.departments ?? [])
        setMobileList(response.data.customer.contact_numbers ?? [])
        setEmailList(response.data.customer.emails ?? [])

      }
    }
  }
  const [locationsOptions, setlocationsOptions] = useState(null);
  const [multipleGatein, setmultipleGatein] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [selectedDept, setSelectedDept] = useState([]);
  const handleAssignToDropdownChange = (selectedOptions) => {
    console.log(selectedOptions);
    setlocationsOptions(selectedOptions);
  };
  const modalStyle = {
    overlay: { position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0, 0, 0, 0.5)", opacity: 1, display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000 },
    modal: { backgroundColor: "#ffffff", borderRadius: "16px", boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", width: "718px", overflowY: "auto", minHeight: "fit-content" },
  };

  const [loading, setLoading] = useState(false);
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [contactNo, setcontactNo] = useState("");


  const getLocationData = (inputValue, callback) => {
    setTimeout(async () => {
      console.log("Fetching transport options with term:", inputValue);
      const response = await getLocationApi(inputValue);
      if (response.status === 200) {
        if (response.data.success === true) {
          const options = response.data.suggestionlist.map((item) => ({
            value: String(item.value),
            label: String(item.label),
          }));
          callback(options);
        }
      }
    }, 1000);
  };
  const getDepartmentData = (inputValue, callback) => {
    setTimeout(async () => {
      console.log("Fetching transport options with term:", inputValue);
      const response = await getDeptApi(inputValue);
      if (response.status === 200) {
        if (response.data.success === true) {
          const options = response.data.suggestionlist.map((item) => ({
            value: String(item.value),
            label: String(item.label),
          }));
          callback(options);
        }
      }
    }, 1000);
  };


  const multiselectCustomStyles = {
    control: (provided) => ({ ...provided, backgroundColor: "#ffffff", borderRadius: "8px", border: "0.7px solid #E5E5E5", padding: "2px", fontWeight: "500", fontSize: "13px", color: "#212129" }),
    option: (provided, state) => ({ ...provided, backgroundColor: state.isSelected ? "#007bff" : state.isFocused ? "#e0e0e0" : "#fff", color: state.isSelected ? "#fff" : "#333", padding: 10 }),
    multiValue: (provided) => ({ ...provided, backgroundColor: "#F6F7F8", color: "#212129", borderRadius: "5px", padding: "2px 5px" }),
    multiValueLabel: (provided) => ({ ...provided, color: "#212129" }),
    multiValueRemove: (provided) => ({ ...provided, color: "#212129", cursor: "pointer", ":hover": { backgroundColor: "red", color: "white" } }),
  };










  const handleLocationChange = (selectedOptions) => {
    console.log(selectedOptions);
    setSelectedLocation(selectedOptions);
  };
  const handleDeptChange = (selectedOptions) => {
    console.log(selectedOptions);
    setSelectedDept(selectedOptions);
  };
  const saveCustomer = async () => {
    try {
      const payload = {
        "code": code,
        "name": name,
        "emails": emailList,
        "contact_numbers": mobileList,
        "locations": selectedLocation.map(item => item.value),
        "departments": selectedDept.map(item => item.value),
      };
      const dataAfterSanitize = {};
      Object.entries(payload).forEach(([key, value]) => {
        if (typeof value === "boolean" || typeof value === "number" || Array.isArray(value)) {
          dataAfterSanitize[key] = value;
        } else {
          dataAfterSanitize[key] = DOMPurify.sanitize(value);
        }
      });
      let response;
      if (povId === null) {
        response = await saveCustomerApi(dataAfterSanitize);
      } else {
        response = await updateCustomerApi(dataAfterSanitize, povId);
      }


      console.log('response', response);
      if (response.status === 400) {
        const validationTemp = {
          code: "",
          name: "",
          email: "",
          contact_number: "",
          locations: "",
          departments: "",
        };

        // Safely iterate over the errors and pick the first message if available
        if (response.data?.error) {
          Object.entries(response.data.error).forEach(([key, value]) => {
            // Make sure value is an array and has at least one item
            validationTemp[key] = Array.isArray(value) && value.length > 0 ? value[0] : '';
          });
        }

        setValidations(validationTemp);
      } else {

      }

      if (response.data.success === true) {
        onSuccess(response.data)
      }


    } catch (err) {
      console.error("Error fetching category:", err);
    }
  };

  return (
    <div style={modalStyle.overlay}>
      <div style={modalStyle.modal}>
        <div style={{ color: "#ffffff" }}>


          <div className="modal-header style-justify-between">
            <div className="add-item-modal-title">{povId != null ? "Edit " : "Add "} Customers</div>
            <ModalCloseIcon style={{ cursor: "pointer" }} onClick={onCancel} />
          </div>
          <div style={{ padding: "16px 24px" }}>
            <Row style={{ width: "670px" }}>
              <Col xs={12} sm={12} md={6} style={{ marginBottom: "16px" }}>
                <div className="field-title">
                  Code<span style={{ color: "#FF4444" }}>*</span>
                </div>
                <input type="text" placeholder="Enter here" className="input-field mt-2 w-100" value={code} onChange={(e) => setCode(e.target.value)} />
                <span className="field-error">{validations.code}</span>
              </Col>

              <Col xs={12} sm={12} md={6} style={{ marginBottom: "16px" }}>
                <div className="field-title">
                  Customer Name<span style={{ color: "#FF4444" }}>*</span>
                </div>
                <input type="text" placeholder="Enter here" className="input-field mt-2 w-100" value={name} onChange={(e) => setName(e.target.value)} />
                <span className="field-error">{validations.name}</span>
              </Col>



              {/* <Col xs={12} sm={12} md={6} style={{ marginBottom: "16px" }}>
                <div className="field-title">
                  Email

                </div>
                <input type="text" placeholder="Enter here" className="input-field mt-2 w-100" value={email} onChange={(e) => setEmail(e.target.value)} />
                <span className="field-error">{validations.email}</span>
              </Col> */}
              <Col xs={12} sm={12} md={6} style={{ marginBottom: "16px" }}>
                <div className="field-title">
                  Location
                  {/* <span style={{ color: "#FF4444" }}>*</span> */}
                </div>
                <AsyncSelect isMulti cacheOptions value={selectedLocation} loadOptions={getLocationData} onChange={handleLocationChange} defaultOptions placeholder="Select locations" styles={multiselectCustomStyles}

                  menuPosition="fixed" isClearable={false} />
                <span className="field-error">{validations.locations}</span>
              </Col>

              <Col xs={12} sm={12} md={6} style={{ marginBottom: "16px" }}>
                <div className="field-title">
                  Department
                  {/* <span style={{ color: "#FF4444" }}>*</span> */}
                </div>
                <AsyncSelect isMulti cacheOptions value={selectedDept} loadOptions={getDepartmentData} onChange={handleDeptChange} defaultOptions placeholder="Select department" styles={multiselectCustomStyles} isClearable={false} />
                <span className="field-error">{validations.departments}</span>
              </Col>
              <Col xs={12} sm={12} md={6} style={{ marginBottom: "16px" }}>
                <div className="field-title">Mobile Number</div>

                <div className="input-group mt-2">
                  <input
                    type="number"
                    className="form-control input-field"
                    placeholder="Enter here"
                    value={contactNo}
                    onChange={(e) => setcontactNo(e.target.value)}
                  />
                  <div
                    className="custom-btn"
                    type="button"
                    onClick={handleAddMobile}
                  >
                    Add
                  </div>

                </div>
                {/* <div className="field-title">
                  Mobile Number

                </div>
                <input type="text" placeholder="Enter here" className="input-field mt-2 w-100" value={contactNo} onChange={(e) => setcontactNo(e.target.value)} /> */}
                <span className="field-error">{validations.contact_number}</span>
                {mobileList.length > 0 && (
                  <div className="field-title mt-2">Added Mobile No</div>
                )}


                <div className="d-flex flex-wrap gap-2 mt-2">
                  {mobileList.map((item, index) => (
                    <div
                      key={index}
                      className="d-flex align-items-center"
                      style={{
                        backgroundColor: "#f0f0f0",
                        color: "#333",
                        padding: "4px 10px",
                        borderRadius: "16px",
                        border: "1px solid #ddd",
                        fontSize: "14px",
                        lineHeight: "1"
                      }}
                    >
                      <span style={{ marginRight: "8px" }}>{item}</span>
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={() => handleRemoveMobile(index)}
                      >
                        <CrossIcon />
                      </span>
                    </div>
                  ))}
                </div>
              </Col>
              <Col xs={12} sm={12} md={6} style={{ marginBottom: "16px" }}>
                <div className="field-title">Email</div>

                <div className="input-group mt-2">
                  <input
                    type="text"
                    className="form-control input-field"
                    placeholder="Enter here"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />

                  <div
                    className="custom-btn"
                    type="button"
                    onClick={handleAddEmail}
                  >
                    Add
                  </div>


                </div>


                <span className="field-error">{validations.email}</span>
                {emailList.length > 0 && (
                  <div className="field-title mt-2">Added Emails</div>
                )}

                <div className="d-flex flex-wrap gap-2 mt-2">
                  {emailList.map((item, index) => (
                    <div
                      key={index}
                      className="d-flex align-items-center"
                      style={{
                        backgroundColor: "#f0f0f0",
                        color: "#333",
                        padding: "4px 10px",
                        borderRadius: "16px",
                        border: "1px solid #ddd",
                        fontSize: "14px",
                        lineHeight: "1"
                      }}
                    >
                      <span style={{ marginRight: "8px" }}>{item}</span>
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={() => handleRemoveEmail(index)}
                      >
                        <CrossIcon />
                      </span>
                    </div>
                  ))}
                </div>
              </Col>



            </Row>

            <Row className="mt-3" style={{ width: "670px" }}>
              <div className="style-justify-end">
                <div onClick={onCancel} className="cancel-modal-btn style-justify-center">
                  Cancel
                </div>
                <div className="save-modal-btn style-justify-center" onClick={() => saveCustomer()}
                >
                  {povId != null ? "Update " : "Save "}
                </div>
              </div>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerCreateModal;
